module.exports = __webpack_public_path__ + "static/media/waveform.b1ad86a2.gif";